const APIS = {
  USER: "/usermanagementservice/api/user/",
  COMMENT: "/commentservice/api/comment/",

  // BLOG_SERVICE_API_ENDPOINTS
  BLOG_OVERVIEW: "/blogservice/api/blog/overview",
  BLOG_STATUS: "/blogservice/api/blog/",
  BLOG_CATEGORY: "/blogservice/api/category/",
  BLOG_TAG: "/blogservice/api/tag/",
  BLOG_AUTHOR: "/blogservice/api/author/",
  BLOG_META_DESCRIPTION: "/blogservice/api/meta-description/",
  FILE_HANDLER: "driveservice/api/file/",
};

export default APIS;
